<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{data.titlePrefix || (data.data ? 'Edit' : 'Add New')}} {{data.title}}
</h1>
<div mat-dialog-content>
    <form [formGroup]="form">
        <ng-container *ngFor="let field of data.fields; let i = index">
            <div *ngIf="field.sectionTitle" class="formSectionTitle">
                {{field.sectionTitle}}
            </div>
            <mat-form-field
              appearance="fill"
              floatLabel="always"
              class="{{field.readOnly ? 'fieldDisabled' : undefined}}"
              *ngIf="!field.invisible?.(form) && !(fieldsOutsideMatFormField.includes(field.fieldType))"
            >
                <mat-label>{{getFieldLabel(field)}}</mat-label>
                <button
                        *ngIf="field.help"
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="fieldHelpButton"
                        [matMenuTriggerFor]="fieldHelpMenu"
                        aria-label="Show field help"
                        (click)="$event.stopPropagation()"
                >
                    <mat-icon>help_outline</mat-icon>
                </button>
                <mat-menu #fieldHelpMenu="matMenu" class="fieldHelpMenu" xPosition="before">
                    <div class="fieldHelpPanel" (click)="$event.stopPropagation()">
                        <div class="fieldHelpTitle">{{field.help?.title}}</div>
                        <div *ngIf="field.help?.description" class="fieldHelpDescription">{{field.help?.description}}</div>
                        <div *ngFor="let helpGroup of field.help?.groups" class="fieldHelpGroup">
                            <div class="fieldHelpGroupTitle">{{helpGroup.title}}</div>
                            <code *ngFor="let helpField of helpGroup.fields">{{helpField}}</code>
                        </div>
                    </div>
                </mat-menu>

                <!-- String Input -->
                <input *ngIf="field.fieldType === fieldType.F_STRING" matInput placeholder="{{field.placeholder || ''}}" [formControlName]="field.name">

                <!-- Number Input -->
                <input *ngIf="field.fieldType === fieldType.F_NUMBER" type="number" matInput placeholder="" [formControlName]="field.name">

                <!-- SSN Input -->
                <input *ngIf="field.fieldType === fieldType.F_SSN" [type]="field.hidePassword ? 'password' : 'text'" pattern="^\d{3}-?\d{2}-?\d{4}$" matInput placeholder="" [formControlName]="field.name">
                <button *ngIf="field.fieldType === fieldType.F_SSN" mat-icon-button matSuffix (click)="field.hidePassword = !field.hidePassword" [attr.aria-label]="'Toggle password visibility'" [attr.aria-pressed]="!field.hidePassword">
                    <mat-icon>{{ field.hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>

                <!-- Phone Input -->
                <input *ngIf="field.fieldType === fieldType.F_PHONE" type="tel" matInput placeholder="" [formControlName]="field.name">

                <!-- Email Input -->
                <input *ngIf="field.fieldType === fieldType.F_EMAIL" type="email" matInput placeholder="" [formControlName]="field.name">

                <!-- Currency Input -->
                <input *ngIf="field.fieldType === fieldType.F_CURRENCY" type="currency" matInput placeholder="" [formControlName]="field.name">

                <!-- Past/Future Date Input -->
                <input *ngIf="field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE"
                       [matDatepicker]="picker" matInput placeholder=""
                       [formControlName]="field.name" [min]="field.minDate" [max]="field.maxDate">
                <mat-datepicker-toggle matSuffix [for]="picker"
                                       *ngIf="field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE">
                </mat-datepicker-toggle>
                <button
                        *ngIf="form.get(field.name)?.value && (field.fieldType === fieldType.F_PASTDATE || field.fieldType === fieldType.F_FUTUREDATE || field.fieldType === fieldType.F_ANYDATE)"
                        mat-icon-button
                        matSuffix
                        aria-label="Clear date"
                        (click)="form.get(field.name)?.reset()"
                        tabindex="-1"
                >
                    <mat-icon>close</mat-icon>
                </button>

                <!-- Color selection -->
                <!-- TODO: implement color selector -->
                <div *ngIf="field.fieldType === fieldType.F_COLOR" class="colorField">
                    <input matInput placeholder="" [formControlName]="field.name">
                    <div class="brandColor" style="background-color: {{form.value[field.name]}}"></div>
                </div>

                <!-- Dropdown -->
                <mat-select
                  *ngIf="field.fieldType === fieldType.F_DROPDOWN"
                  [multiple]="field.multiple"
                  [formControlName]="field.name"
                  placeholder="{{field.placeholder || ''}}"
                  [panelClass]="field.searchable ? 'member-addedit-select-search-panel' : ''"
                >
                    <mat-option *ngIf="field.searchable" [disabled]="true">
                        <ngx-mat-select-search
                          [formControl]="getDropdownSearchControl(field.name)"
                          noEntriesFoundLabel="No matches"
                          [placeholderLabel]="getSearchPlaceholder(field)"
                        ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let value of getFilteredFieldValues(field)" [value]="value.split(':')[1] || value">
                        {{value.split(':')[0]}}
                    </mat-option>
                </mat-select>
                <app-state *ngIf="field.fieldType === fieldType.F_STATE" [formControlName]="field.name"></app-state>
                <app-json *ngIf="field.fieldType === fieldType.F_JSON" [formControlName]="field.name" [readOnly]="!!field.readOnly"></app-json>
                <mat-hint *ngIf="field.hint">{{field.hint}}</mat-hint>
                <!-- Field validation error display -->
                <mat-error *ngIf="form.get(field.name)?.hasError('required')">
                    {{getFieldLabel(field)}} is required
                </mat-error>
                <mat-error *ngIf="form.get(field.name)?.hasError('currency')">
                    Please enter a valid amount, no $, no commas
                </mat-error>
                <mat-error *ngIf="form.get(field.name)?.hasError('email')">
                    Please enter a valid email address
                </mat-error>
            </mat-form-field>
            <mat-datepicker #picker></mat-datepicker>

            <!-- Slide toggle -->
            <!-- mat-slide-toggle should not be displayed within a mat-form-field, so we create and style
                 separately (source: https://material.angular.dev/components/form-field/overview) -->
            <div *ngIf="field.fieldType === fieldType.F_TOGGLE && !field.invisible?.(form)" class="fieldOutsideMatFormField">
                <div>
                    <mat-label [id]="field.name + '-label'">{{field.label}}</mat-label>
                    <div *ngIf="field.hint" class="fieldHint" [id]="field.name + '-hint'">{{field.hint}}</div>
                </div>
                <mat-slide-toggle [checked]="form.value[field.name]" [formControlName]="field.name"
                                  [aria-labelledby]="field.name + '-label'"
                                  [aria-describedby]="field.hint ? field.name + '-hint' : ''"></mat-slide-toggle>
            </div>

            <div *ngIf="field.fieldType === fieldType.F_ACTION_BUTTON && !field.invisible?.(form)" class="fieldOutsideMatFormField actionButtonField">
                <button
                        mat-stroked-button
                        color="primary"
                        type="button"
                        [disabled]="isFieldActionDisabled(field)"
                        (click)="runFieldAction(field)"
                >
                    <mat-icon *ngIf="field.actionIcon">{{field.actionIcon}}</mat-icon>
                    {{getFieldLabel(field)}}
                </button>
            </div>

            <div *ngIf="field.fieldType === fieldType.F_PRIMARY_INSURANCE_CUSTOM_FIELDS && !field.invisible?.(form)" class="primaryInsuranceCustomFieldsEditor">
                <div class="primaryInsuranceCustomFieldsHeader">
                    <mat-label>{{field.label}}</mat-label>
                    <button mat-stroked-button color="primary" type="button" (click)="addPrimaryInsuranceCustomFieldRow(field.name)">
                        Add Field
                    </button>
                </div>
                <div *ngIf="!getPrimaryInsuranceCustomFieldRows(field.name).length" class="primaryInsuranceCustomFieldsEmpty">
                    No custom fields configured yet.
                </div>
                <div
                        *ngFor="let row of getPrimaryInsuranceCustomFieldRows(field.name); let rowIndex = index; trackBy: trackByIndex"
                        class="primaryInsuranceCustomFieldRow"
                >
                    <mat-form-field appearance="fill">
                        <mat-label>Field Name</mat-label>
                        <input
                                matInput
                                [ngModel]="row.fieldName"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="eyeColor"
                                (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'fieldName', $event)"
                        >
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Label</mat-label>
                        <input
                                matInput
                                [ngModel]="row.label"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Eye Color"
                                (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'label', $event)"
                        >
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Type</mat-label>
                        <mat-select
                                [ngModel]="row.type"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'type', $event)"
                        >
                            <mat-option *ngFor="let type of primaryInsuranceCustomFieldTypes" [value]="type.value">
                                {{type.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button
                            mat-icon-button
                            type="button"
                            aria-label="Remove custom field"
                            class="primaryInsuranceCustomFieldRemove"
                            (click)="removePrimaryInsuranceCustomFieldRow(field.name, rowIndex)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    <mat-form-field *ngIf="row.type === 'dropdown'" appearance="fill" class="primaryInsuranceCustomFieldOptions">
                        <mat-label>Dropdown Options</mat-label>
                        <input
                                matInput
                                [ngModel]="row.optionsText"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Brown, Blue"
                                (ngModelChange)="updatePrimaryInsuranceCustomField(field.name, rowIndex, 'optionsText', $event)"
                        >
                        <mat-hint>Comma-separated values</mat-hint>
                    </mat-form-field>
                </div>
                <div *ngIf="field.hint" class="fieldHint">{{field.hint}}</div>
                <div *ngIf="form.get(field.name)?.invalid && form.get(field.name)?.touched" class="fieldError">
                    Invalid custom fields. Field name must start with a letter, and dropdowns need at least one option.
                </div>
            </div>

            <!-- Image selection -->
            <div *ngIf="field.fieldType === fieldType.F_IMAGE && !field.invisible?.(form)" >
                <mat-label >{{field.label}}</mat-label>
                <div class="fieldOutsideMatFormField">
                    <input
                        accept="image/png, image/jpeg"
                        type="file"
                        id="{{field.name}}FileInput"
                        (change)="imageFileChange($event, field.name)"
                    >
                    <button
                        *ngIf="form.value[field.name + 'ImageDataSrc'] || form.value[field.name]"
                        mat-stroked-button
                        type="button"
                        (click)="clearImageField(field.name)"
                    >
                        Clear
                    </button>
                    <img
                        *ngIf="form.value[field.name + 'ImageDataSrc'] || form.value[field.name]"
                        alt="{{field.label}}"
                        class="brandLogo"
                        src="{{form.value[field.name + 'ImageDataSrc'] || form.value[field.name]}}"
                    >
                </div>
            </div>
        </ng-container>
    </form>
    <span class="required">* Required Field</span>
</div>
<div class="buttons" mat-dialog-actions>
    <div class="validationBox" *ngIf="validationMessages.length">
        <h3>Fix these items first</h3>
        <ul>
            <li *ngFor="let message of validationMessages">{{message}}</li>
        </ul>
    </div>
    <ng-container *ngIf="data.titlePrefix === 'View'; else editButtons">
        <button mat-raised-button class="donebutton" color="primary" (click)="onDismiss()">Close</button>
    </ng-container>
    <ng-template #editButtons>
        <button mat-raised-button class="donebutton" color="primary" [disabled]="isOkDisabled()" (click)="okClicked()">OK</button>
        <button mat-button (click)="onDismiss()">Cancel</button>
    </ng-template>
</div>
